import lastTimestampFromPricesMap from './last-timestamp-from-prices-map.js';
import { timeToDays, timeToHours, timeToMinutes } from './utils.js';
const START_TIME = new Date('2015-12-09').getTime();
const getLimit = ({ granularity, history, requestLimit, requestTimestamp, specificTimestamp, }) => {
    if (specificTimestamp)
        return 1;
    const lastCachedTime = lastTimestampFromPricesMap(history);
    if (granularity === 'minute') {
        if (!lastCachedTime)
            return requestLimit;
        return Math.ceil(Math.min(requestLimit, timeToMinutes(requestTimestamp - lastCachedTime)));
    }
    if (granularity === 'hour') {
        if (!lastCachedTime)
            return requestLimit;
        return Math.min(requestLimit, timeToHours(requestTimestamp - lastCachedTime));
    }
    return Math.min(requestLimit, timeToDays(requestTimestamp - (lastCachedTime || START_TIME)));
};
export default getLimit;
